(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("classnames"), require("lodash"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["classnames", "lodash", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["perseusApp"] = factory(require("classnames"), require("lodash"), require("react"), require("react-dom"));
	else
		root["perseusApp"] = factory(root["classNames"], root["_"], root["React17"], root["ReactDOM17"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_IX_1__, __WEBPACK_EXTERNAL_MODULE_luq0__, __WEBPACK_EXTERNAL_MODULE_yHGu__, __WEBPACK_EXTERNAL_MODULE__4LQx__) => {
return 